import { Component, OnInit } from '@angular/core';
//services
import { TimeoutService } from '../../core/services/timeout.service';
@Component({
    selector: 'app-sm-layout',
    templateUrl: './sm-layout.component.html',
    styleUrls: ['./sm-layout.component.css'],
    standalone: false
})
export class SmLayoutComponent implements OnInit {
  constructor(private timeoutService: TimeoutService) {}

  ngOnInit(): void {
    this.timeoutService.initializeTimeoutConfig();
  }
}
